"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Input = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Icon = require("../../Icon");

var _InputBase = _interopRequireDefault(require("./InputBase"));

var _InputPassword = _interopRequireDefault(require("./InputPassword"));

var _InputSearch = _interopRequireDefault(require("./InputSearch"));

const _excluded = ["icon", "iconRight", "size", "type"];

const Input = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    icon,
    iconRight,
    size,
    type
  } = _ref,
      inputProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (type === 'search') {
    return /*#__PURE__*/_react.default.createElement(_InputSearch.default, (0, _extends2.default)({
      ref: ref,
      size: size,
      icon: icon,
      iconRight: iconRight
    }, inputProps));
  }

  if (type === 'password') {
    return /*#__PURE__*/_react.default.createElement(_InputPassword.default, (0, _extends2.default)({
      ref: ref,
      size: size,
      icon: icon,
      iconRight: iconRight
    }, inputProps));
  }

  return /*#__PURE__*/_react.default.createElement(_InputBase.default, (0, _extends2.default)({
    prefixElement: icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      name: icon,
      size: size
    }),
    suffixElement: iconRight && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      name: iconRight,
      size: size
    }),
    ref: ref,
    type: type,
    size: size
  }, inputProps));
});

exports.Input = Input;
Input.displayName = 'Input';
var _default = Input;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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